import { Component, Inject } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { AdmFieldGroup } from "../../api/models/adm-field-group";
import { DialogResult, DialogResultType } from "../DialogResult";

export interface AdmFieldGroupDialogData {
  fieldGroup: AdmFieldGroup;
}

// Admin ADM Definition > Tables & Columns > a table's display-only field groups. Delete is hard (a field group
// carries no downstream meaning - see AdminAdmDefinitionController.DeleteFieldGroup), so this returns
// ResultType.Delete to delete rather than toggle retired.
@Component({
  selector: "adm-field-group-dialog",
  templateUrl: "./adm-field-group-dialog.component.html",
})
export class AdmFieldGroupDialogComponent {
  public result: AdmFieldGroup;
  public Result: DialogResult = { ResultType: DialogResultType.Cancel, ResultData: null };

  constructor(public dialogRef: MatDialogRef<AdmFieldGroupDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: AdmFieldGroupDialogData) {
    this.result = { ...data.fieldGroup };
  }

  get isNew(): boolean {
    return !this.data.fieldGroup.admFieldGroupId;
  }

  onSave(): void {
    this.Result.ResultType = DialogResultType.Ok;
    this.Result.ResultData = this.result;
    this.dialogRef.close(this.Result);
  }

  onDelete(): void {
    this.Result.ResultType = DialogResultType.Delete;
    this.Result.ResultData = this.result;
    this.dialogRef.close(this.Result);
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  static showDialog(dialog: MatDialog, data: AdmFieldGroupDialogData): Observable<DialogResult> {
    return dialog.open(AdmFieldGroupDialogComponent, { disableClose: false, width: "500px", data }).afterClosed();
  }
}
